"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _moment = _interopRequireDefault(require("moment"));
var MutationTypes = _interopRequireWildcard(require("../mutation-types"));
var _underLoading = require("../helpers/under-loading");
var _helpers = require("@/helpers");
var _utils = require("@/utils");
var _app = _interopRequireDefault(require("@/services/app.service"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var state = {
  sidebar: {
    opened: _jsCookie.default.get('sidebarStatusItajuba') ? !!+_jsCookie.default.get('sidebarStatusItajuba') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: _jsCookie.default.get('size') || 'medium',
  isLoading: false,
  activeLoadingRequests: 0,
  tituloLoading: '',
  header: {
    title: {
      title: '',
      icon: '',
      align: ''
    },
    right: true,
    hidden: true
  },
  /* NavBar */
  isNavBarVisible: true,
  isAsideVisible: true,
  isFooterBarVisible: true
};
var mutations = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MutationTypes.TOGGLE_SIDEBAR, function (mutationState) {
  mutationState.sidebar.opened = !mutationState.sidebar.opened;
  mutationState.sidebar.withoutAnimation = false;
  if (mutationState.sidebar.opened) {
    _jsCookie.default.set('sidebarStatusItajuba', 1, {
      secure: true,
      sameSite: 'None'
    });
  } else {
    _jsCookie.default.set('sidebarStatusItajuba', 0, {
      secure: true,
      sameSite: 'None'
    });
  }
}), MutationTypes.CLOSE_SIDEBAR, function (mutationState, withoutAnimation) {
  _jsCookie.default.set('sidebarStatusItajuba', 0, {
    secure: true,
    sameSite: 'None'
  });
  mutationState.sidebar.opened = false;
  mutationState.sidebar.withoutAnimation = withoutAnimation;
}), MutationTypes.TOGGLE_DEVICE, function (mutationState, device) {
  mutationState.device = device;
}), MutationTypes.SET_SIZE, function (mutationState, size) {
  mutationState.size = size;
  _jsCookie.default.set('size', size, {
    secure: true,
    sameSite: 'None'
  });
}), MutationTypes.SET_LOADING, function (mutationState, isLoading) {
  mutationState.activeLoadingRequests = isLoading ? mutationState.activeLoadingRequests + 1 : Math.max(0, mutationState.activeLoadingRequests - 1);
  mutationState.isLoading = mutationState.activeLoadingRequests > 0;
}), MutationTypes.SET_TEXT_LOADING, function (mutationState, text) {
  mutationState.tituloLoading = text;
}), MutationTypes.UPDATE_HEADER, function (mutationState, header) {
  mutationState.header = header;
}), "fullPage", function fullPage(state, payload) {
  state.isNavBarVisible = !payload;
  state.isAsideVisible = !payload;
  state.isFooterBarVisible = !payload;
});
var actions = {
  uploadToS3: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref, _ref2) {
      var commit, rootState, state, image, typeFile, randomName, name, nameFile, base64, payload, _yield$AppService$upl, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref.commit, rootState = _ref.rootState, state = _ref.state;
            image = _ref2.image, typeFile = _ref2.typeFile;
            _context.p = 1;
            commit(MutationTypes.SET_TEXT_LOADING, 'Validando anexos...');
            randomName = (0, _utils.generateRandomName)(4);
            name = 'hiveplace_backoffice_' + (0, _moment.default)().toDate().getTime() + '_' + randomName;
            nameFile = name;
            _context.n = 2;
            return (0, _utils.createBase64Image)(image);
          case 2:
            base64 = _context.v;
            payload = {
              name: nameFile,
              type: image.type,
              originalName: image.name,
              file: base64
            };
            _context.n = 3;
            return _app.default.uploadFile(payload);
          case 3:
            _yield$AppService$upl = _context.v;
            data = _yield$AppService$upl.data;
            commit(MutationTypes.SET_TEXT_LOADING, '');
            return _context.a(2, data.url);
          case 4:
            _context.p = 4;
            _t = _context.v;
            _helpers.errorResponseHelper.display(_t);
            return _context.a(2, false);
        }
      }, _callee, null, [[1, 4]]);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }()),
  toggleSideBar: function toggleSideBar(_ref4) {
    var commit = _ref4.commit;
    commit(MutationTypes.TOGGLE_SIDEBAR);
  },
  closeSideBar: function closeSideBar(_ref5, _ref6) {
    var commit = _ref5.commit;
    var withoutAnimation = _ref6.withoutAnimation;
    commit(MutationTypes.CLOSE_SIDEBAR, withoutAnimation);
  },
  toggleDevice: function toggleDevice(_ref7, device) {
    var commit = _ref7.commit;
    commit(MutationTypes.TOGGLE_DEVICE, device);
  },
  setSize: function setSize(_ref8, size) {
    var commit = _ref8.commit;
    commit(MutationTypes.SET_SIZE, size);
  },
  setLoading: function setLoading(_ref9, status) {
    var commit = _ref9.commit;
    commit(MutationTypes.SET_LOADING, status);
  },
  setTextLoading: function setTextLoading(_ref0, text) {
    var commit = _ref0.commit;
    commit(MutationTypes.SET_TEXT_LOADING, text);
  },
  updateHeader: function updateHeader(_ref1, header) {
    var commit = _ref1.commit;
    commit(MutationTypes.UPDATE_HEADER, header);
  },
  toggleFullPage: function toggleFullPage(_ref10, payload) {
    var commit = _ref10.commit;
    commit('fullPage', payload);
    document.documentElement.classList[!payload ? 'add' : 'remove']('has-aside-left', 'has-navbar-fixed-top');
  }
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  actions: actions
};